import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../shared/nestjs/nest-api";
import {GetAllDataEmpData, ResponseSaveChangeDto,} from "../../shared/nestjs/gd-only/dto/sf-change-spv.dto";
import {SharedLogic} from "./shared.logic";

@Injectable()
export class ChangeSpvLogic {
  constructor(
    private nestApiProvider: NestApiProvider,
    private sharedLogic: SharedLogic,
  ) {
  }

  getAllDataEmp(companyId): Promise<GetAllDataEmpData[]> {
    return new Promise<GetAllDataEmpData[]>(async (resolve, reject) => {
      const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
      try {
        if (isGoPathNewExist) {
          const result = await this.sharedLogic.getAllDataEmpNest();
          const output = [];
          let idx = 0;
          for (const dt of result.data) {
            // @ts-ignore
            dt.isShowHide = true;
            if (idx > 0) {
              if (result.data[idx + 1] != undefined) {
                if (dt.level.length < result.data[idx + 1].level.length) {
                  // @ts-ignore
                  dt.isShowHide = false;
                }
              }
            }

            output.push(dt);
            idx++;
          }
          resolve(output);
        } else {
          const result = await this.sharedLogic.getAllDataEmpLB(companyId);
          let idx = 0;
          const output = [];
          for (const dt of result) {
            dt.isShowHide = true;
            if (idx > 0) {
              if (result[idx + 1] != undefined) {
                if (dt.level.length < result[idx + 1].level.length) {
                  dt.isShowHide = false;
                }
              }
            }

            output.push(dt);
            idx++;
          }
          resolve(output);
        }
      } catch (e) {
        reject(e);
      }
    })
  }

  saveTeam(editFlag, data, head): Promise<ResponseSaveChangeDto> {
    return new Promise<ResponseSaveChangeDto>(async (resolve, reject) => {
      const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
      if (editFlag == 1) {
        try {
          const result = await this.sharedLogic.saveChangePartialLB(data, head);
          const output = {
            message: result.msg,
            data: null,
          };
          resolve(output);
        } catch (e) {
          reject(e);
        }
      } else {
        try {
          if (isGoPathNewExist) {
            const result = await this.sharedLogic.saveChangeNest(data);
            resolve(result);
          } else {
            const result = await this.sharedLogic.saveChangeLB(data);
            const output = {
              message: result.msg,
              data: null,
            };
            resolve(output);
          }
        } catch (e) {
          reject(e);
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/component-logic/change-spv.logic.ts